import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c447e33"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg arrow-right" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "value-tip"
}
const _hoisted_3 = {
  key: 0,
  class: "icon-arrow-right-svg arrow-right"
}
const _hoisted_4 = {
  key: 2,
  class: "desc-textarea empty-text"
}

import { withDefaults, computed, ref } from 'vue'
import CommonImagePreview from '@/components/CommonFilePreView.vue'
import UploadImg from '@/components/upload/UploadFile.vue'
import type { CommonUploaderFileListItem } from '@/types/public'
import { Field } from 'vant'
import dayjs from 'dayjs'

export interface ItemInfoProps {
  prop?: string
  title: string
  value?: string | number | Array<string | number> | CommonUploaderFileListItem[]
  valueTip?: string
  isRequired?: boolean
  tip?: string
  tipStyle?: object
  isRequiredBottom?: boolean
  isShowArrowRight?: boolean
  imgags?: Array<string>
  uiType?: string
  isShow?: boolean
  valueError?: boolean
  valueOmission?: boolean
  isEdit?: boolean
  acceptValue?: string
  clickHandle?: ClickHandle
  editTip?: string
  createdAt?: Date
  formatter?: (value: string) => string
}

export type ClickHandle = (item: ItemInfoProps) => void


export default /*#__PURE__*/_defineComponent({
  __name: 'item-info',
  props: {
    prop: null,
    title: null,
    value: null,
    valueTip: null,
    isRequired: { type: Boolean, default: false },
    tip: null,
    tipStyle: null,
    isRequiredBottom: { type: Boolean, default: true },
    isShowArrowRight: { type: Boolean, default: false },
    imgags: null,
    uiType: null,
    isShow: { type: Boolean, default: true },
    valueError: { type: Boolean },
    valueOmission: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: true },
    acceptValue: null,
    clickHandle: null,
    editTip: null,
    createdAt: null,
    formatter: null
  },
  emits: ["valueChange", "showCreatedAtPopup"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'valueChange', value: ItemInfoProps): void
  (event: 'showCreatedAtPopup'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { prop?: string, title: string, value?: string | number | Array<string | number> | CommonUploaderFileListItem[], valueTip?: string, isRequired: boolean, tip?: string, tipStyle?: object, isRequiredBottom: boolean, isShowArrowRight: boolean, imgags?: Array<string>, uiType?: string, isShow: boolean, valueError?: boolean, valueOmission: boolean, isEdit: boolean, acceptValue?: string, clickHandle?: ClickHandle, editTip?: string, createdAt?: Date, formatter?: (value: string) => string };




const showCreatedAtValue = computed(() => {
  return props.createdAt ? dayjs(props.createdAt).format('YYYY-MM-DD') : ''
})
let data = computed(() => {
  return props
})
function itemClickHandle() {
  if (data.value.clickHandle) {
    data.value.clickHandle(data.value)
  }
}

function showDatePicker() {
  emit('showCreatedAtPopup')
}
function valueChangeHandle(value: string) {
  emit('valueChange', { ...data.value, value })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(data).isShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item-wrap", { 'van-hairline--bottom': _unref(data).isRequiredBottom }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["title", { 'red-star': _unref(data).isRequired }])
          }, _toDisplayString(_unref(data).title), 3),
          (_unref(data).isEdit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "value",
                onClick: itemClickHandle
              }, [
                (_unref(data).uiType)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(data).uiType === 'field')
                        ? (_openBlock(), _createBlock(_unref(Field), {
                            key: 0,
                            "model-value": (_unref(data).value as string|number),
                            "onUpdate:modelValue": valueChangeHandle,
                            style: { paddingLeft: 0 },
                            formatter: _unref(data).formatter || undefined,
                            placeholder: _unref(data).valueTip,
                            class: "field"
                          }, null, 8, ["model-value", "formatter", "placeholder"]))
                        : _createCommentVNode("", true),
                      (_unref(data).uiType === 'uploadImg')
                        ? (_openBlock(), _createBlock(UploadImg, {
                            key: 1,
                            "accept-value": _unref(data).acceptValue,
                            "default-list": (_unref(data).value as CommonUploaderFileListItem[]),
                            onChange: valueChangeHandle
                          }, null, 8, ["accept-value", "default-list"]))
                        : _createCommentVNode("", true),
                      (_unref(data).uiType === 'timePicker')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "date-picker-wrap",
                            onClick: showDatePicker
                          }, [
                            _createElementVNode("div", null, _toDisplayString(_unref(showCreatedAtValue)), 1),
                            _hoisted_1
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: "date-value-wrap",
                        style: _normalizeStyle({ width: _unref(data).isShowArrowRight ? '90%' : '100%' })
                      }, [
                        (Array.isArray(_unref(data).value) ? _unref(data).value.length : _unref(data).value)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array.isArray(_unref(data).value) ? _unref(data).value : [_unref(data).value], (dataValue, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(["date-value", { 'vlaue-error': _unref(data).valueError, 'value-omission': _unref(data).valueOmission }])
                              }, _toDisplayString(dataValue), 3))
                            }), 128))
                          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(data).valueTip), 1))
                      ], 4),
                      (_unref(data).isShowArrowRight)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                        : _createCommentVNode("", true)
                    ], 64))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(data)?.imgags?.length)
                  ? (_openBlock(), _createBlock(CommonImagePreview, {
                      key: 0,
                      guids: _unref(data)?.imgags,
                      class: "detail-imag-wrap"
                    }, null, 8, ["guids"]))
                  : (Array.isArray(_unref(data).value) ? _unref(data).value.length : _unref(data).value)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Array.isArray(_unref(data).value) ? _unref(data).value : [_unref(data).value], (dataValue, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["detail-data-value", { 'vlaue-error': _unref(data).valueError, 'value-omission': _unref(data).valueOmission }])
                        }, _toDisplayString(dataValue), 3))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无"))
              ], 64))
        ], 2))
      : _createCommentVNode("", true),
    (_unref(data).tip)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tip",
          style: _normalizeStyle(_unref(data).tipStyle)
        }, _toDisplayString(_unref(data).tip), 5))
      : _createCommentVNode("", true)
  ], 64))
}
}

})